<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page020">
<div class="jstfy" id="page020_1">AÏOLI</div>
<div class="jstfy" id="page020_2">TIME REQUIRED:</div>
<div class="jstfy" id="page020_3">A<span class="small">ïoli hails from</span> Marseille. A grand aïoli is a feast and social</div>
<div class="jstfy" id="page020_4">10 minutes</div>
<div class="jstfy" id="page020_5">occasion to be shared by family and friends.</div>
<div class="jstfy" id="page020_6">80 g white sandwich</div>
<div class="jstfy" id="page020_7">1.</div>
<div class="jstfy" id="page020_7a"><span class="page020_7a"> Squeeze the bread, break it into small pieces and put it into a</span></div>
<div class="jstfy" id="page020_8">bread, crust removed</div>
<div class="jstfy" id="page020_9">blending beaker. Peel and coarsely chop the garlic and add it to</div>
<div class="jstfy" id="page020_10">and soaked in a little</div>
<div class="jstfy" id="page020_11">the bread.</div>
<div class="jstfy" id="page020_12">2.</div>
<div class="jstfy" id="page020_12a"><span class="page020_12a"> Use a hand-held blender to incorporate the oil, first a drop at</span></div>
<div class="jstfy" id="page020_13">water</div>
<div class="jstfy" id="page020_14">a time and then in a stream. If the aïoli is too thick, thin it with a</div>
<div class="jstfy" id="page020_15">200 ml extra-virgin olive</div>
<div class="jstfy" id="page020_16">little soya yoghurt.</div>
<div class="jstfy" id="page020_17">oil</div>
<div class="jstfy" id="page020_18">6 cloves garlic</div>
<div class="jstfy" id="page020_19">Salt, pepper</div>
<div class="jstfy" id="page020_20">B<span class="pagen">asics</span></div>
<div class="jstfy" id="page020_0">20</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_020.vue?28ba3c8c